import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { styled } from "styled-components";

interface DogNameCurvedProps {
  dogName: string;
  color: string;
  textShadow?: string;
  isInHeader?: boolean;
}

export default function DogNameCurved({ dogName, color, textShadow, isInHeader = false }: DogNameCurvedProps) {
  dogName = dogName.toUpperCase();
  const pathRef = useRef<SVGPathElement | null>(null);
  const [fontSize, setFontSize] = useState<number>(16);
  const [letterSpacing, setLetterSpacing] = useState<number>(-7);
  const [viewboxHeight] = useState<number>(30);
  const [pathD, setPathD] = useState<string>("");

  const adjustFontSize = () => {
    if (pathRef.current) {
      const x1 = 2,
        y1 = 53;
      const x2 = 12,
        y2 = 14;
      // y2 = 30;

      const a = (y2 - y1) / (x2 - x1); // pente
      const b = y1 - a * x1; // ordonnée à l'origine

      const fontSize = a * dogName.length + b;
      setFontSize(fontSize);
    }
  };

  const adjustLetterSpacing = () => {
    // Exemple basé sur deux points : (45, -7) et (35, -4)
    // On utilise une interpolation linéaire : y = a * x + b

    const x1 = 45,
      y1 = -7;
    const x2 = 35,
      y2 = -4;

    const a = (y2 - y1) / (x2 - x1); // pente
    const b = y1 - a * x1; // ordonnée à l'origine

    const letterSpacing = a * fontSize + b;
    setLetterSpacing(letterSpacing);
  };

  const adjustCurveAndPath = () => {
    const startX = 20;
    const endX = 180;
    const radius = 10;

    const x1 = 2,
      y1 = isInHeader ? 100 : 115;
    const x2 = 12,
      y2 = isInHeader ? 70 : 90;
    // y2 = 105;

    const a = (y2 - y1) / (x2 - x1); // pente
    const b = y1 - a * x1; // ordonnée à l'origine

    const centerY = a * dogName.length + b;

    // Define the path of the curve dynamically
    const newPathD = `M ${startX} ${centerY} A ${radius} ${radius} 0 0 1 ${endX} ${centerY}`;
    setPathD(newPathD);
  };

  // const adjustsetViewboxHeight = () => {
  //   const x1 = 2,
  //     y1 = 55;
  //   const x2 = 12,
  //     y2 = 90;

  //   const a = (y2 - y1) / (x2 - x1); // pente
  //   const b = y1 - a * x1; // ordonnée à l'origine

  //   const viewboxHeight = a * dogName.length + b;
  //   setViewboxHeight(viewboxHeight);
  // };

  useEffect(() => {
    adjustCurveAndPath();
  }, [dogName]);

  useLayoutEffect(() => {
    adjustFontSize();
  }, [pathD]);

  useEffect(() => {
    // adjustsetViewboxHeight();
    adjustLetterSpacing();
  }, [fontSize]);

  return (
    <RootContainer viewBox={`0 0 200 ${viewboxHeight}`}>
      <path
        ref={pathRef}
        id="MyPath"
        fill="transparent"
        // stroke="red"
        d={pathD}
        // d="M 20 120 A 40 40 0 0 1 180 120"
      />

      <DogNameText $color={color} $letterSpacing={letterSpacing} $textShadow={textShadow}>
        <textPath href="#MyPath" textAnchor="middle" startOffset={"50%"} style={{ fontSize: `${fontSize}px` }}>
          {dogName}
        </textPath>
      </DogNameText>
    </RootContainer>
  );
}

const RootContainer = styled.svg`
  z-index: 99;
  overflow: visible;
  z-index: 99;
  width: 100%; // Really important (Weird behaviour on Safari)
  /* background-color: #0000ff51;
  stroke: red; */
`;

const DogNameText = styled.text<{
  $color: string;
  $letterSpacing?: number;
  $textShadow?: string;
}>`
  text-shadow: ${(props) => props.$textShadow};
  fill: ${(props) => props.$color};
  font-family: ${(props) => props.theme.font.family.label};
  letter-spacing: ${(props) => `${props.$letterSpacing}px`};
  text-shadow: ${(props) => props.theme.font.elevation.dogName};
`;
